/**
 * Whether execution-latency figures (the "834ms" description on fill/close toasts) should be
 * shown. They are a development instrument, not product copy — real users just see "Long filled";
 * the measured request-to-fill milliseconds appear only on the dev hosts, exactly matched.
 */
const LATENCY_DEBUG_HOSTS = new Set(['localhost', '127.0.0.1', 'dev.snappy.app', 'dev.snappy.trade']);

export function isLatencyDebugHost(
    hostname: string = typeof window !== 'undefined' ? window.location.hostname : '',
): boolean {
    return LATENCY_DEBUG_HOSTS.has(hostname);
}
